import BrisbaneGolfClubImage from './Brisbane-Golf-Club.webp'
import BrisbaneGolfClubLogoImage from './Brisbane-Golf-Club-Logo.webp'
import KingstonHeathVicImage from './Kingston-Heath-VIC.webp'
import KingstonHeathVicLogoImage from './Kingston-Heath-VIC-Logo.webp'
import NewSouthWalesNSWImage from './New-South-Wales-NSW.webp'
import NewSouthWalesNSWLogoImage from './New-South-Wales-NSW-Logo.webp'
import TheLakesNSWImage from './The-Lakes-NSW.webp'
import TheLakesNSWLogoImage from './The-Lakes-NSW-Logo.webp'

export {
  BrisbaneGolfClubImage,
  BrisbaneGolfClubLogoImage,
  KingstonHeathVicImage,
  KingstonHeathVicLogoImage,
  NewSouthWalesNSWImage,
  NewSouthWalesNSWLogoImage,
  TheLakesNSWImage,
  TheLakesNSWLogoImage,
}
